<template src="@/templates/portal/contact.html"></template>

<script>
import userApi from '@/api/userApi';
import entityStore from '@/store/entityStore';

export default {
  data() {
    return {
      entity: entityStore.state,
    };
  },
  computed: {
    pageTitle() {
      return 'Contact';
    },
    mailAddress() {
      return this.entity.mailAddress;
    },
    mailToAddress() {
      return `mailto:${this.entity.mailAddress}`;
    },
    telTo() {
      const str = this.cleanPhoneNumber(this.entity.tel);
      return `tel:${str}`;
    },
    telIntTo() {
      const str = this.cleanPhoneNumber(this.entity.telInt);
      return `tel:${str}`;
    },
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  methods: {
    cleanPhoneNumber(str) {
      let str2 = str;
      str2 = str2.replace(/\s/g, '');
      str2 = str2.replace('-', '');
      str2 = str2.replace('(', '');
      str2 = str2.replace(')', '');
      str2 = str2.replace('+', '');
      return str2;
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// contact.vue?4a1d6b73